export default {
  state: {
    packageVersion: process.env.PACKAGE_VERSION || '0',
    loading: false,
    error: null,
    pluginDialog: null,
    snackbar: {
      data: null,
      isActive: false,
    },
    infoDialog: {
      data: null,
      isActive: false,
    },
  },
  actions: {
    onLoading({commit}, payload) {
      commit('SET_LOADING', payload)
    },
    snackbarAction({commit}, payload) {
      commit('SET_SNACKBAR', payload)
    },
    infoDialogAction({commit}, payload) {
      commit('SET_INFO_DIALOG', payload)
    },
    clearAction({commit}) {
      commit('CLEAR_ACTION')
    },
    pluginDialog({commit}, payload) {
      commit('SET_PLUGIN_DIALOG', payload)
    },
  },
  mutations: {
    SET_LOADING(state, payload) {
      state.loading = payload
    },
    SET_SNACKBAR(state, payload) {
      state.snackbar.data = payload.data || null
      state.snackbar.isActive = !state.snackbar.isActive
    },
    SET_INFO_DIALOG(state, payload) {
      state.infoDialog.data = payload.data || null
      state.infoDialog.isActive = !state.infoDialog.isActive
    },
    CLEAR_ACTION(state) {
      state.error = null
      state.pluginDialog = null
    },
    SET_PLUGIN_DIALOG(state, payload) {
      state.pluginDialog = payload
    },
  },
  getters: {
    loading(state) {
      return state.loading
    },
    snackbar(state) {
      return state.snackbar
    },
    getInfoDialog(state) {
      return state.infoDialog
    },
    appVersion: (state) => {
      return state.packageVersion
    },
    getPluginDialog(state) {
      return state.pluginDialog
    },
  },
}
